<template>
    <b-row class="mb-5">
        <b-col md="12">
          <div class="pt-2 pb-2 float-right">
            <a variant="light" style="margin-top:-100px!important; margin-right:10px!important;" class="btn-back btn-custom"></a>
            <!-- <b-button variant="info" style="margin-top:-88px!important;" class="mr-1 btn-download btn-custom" @click="doExportToExcel"><font-awesome-icon icon="download" style="font-size:15px!important;" /></b-button> -->
            <!-- <b-button variant="primary" style="margin-top:-88px!important;" class="btn-back btn-custom" @click="doModal"><font-awesome-icon icon="plus"/></b-button> -->
          </div>
          <paginated-table ref="dataTable" :can-edit="false" :can-delete="false" :can-approve="false" :can-reject="false" :can-show="true" :can-show-route-path="'#/vehicle/penalty-detail'" :can-edit-modal="false" :can-edit-penalty="true" :can-paid="false" v-on:editData="doEdit" :data-url="apiUrl.vehicleBill" :data-key="dataKey" :data-columns="columns">
          </paginated-table>
        </b-col>
      <!-- <type-vehicle-modal ref="typeVehicleModal" :type-vehicle="'Penalty'" v-on:getPenaltyBill="getPenaltyBill"></type-vehicle-modal> -->
      <edit-penalty-modal ref="editPenalty" v-on:getPenaltyBill="getPenaltyBill"></edit-penalty-modal>
    </b-row>
</template>
<script>
  import PaginatedTable from '@/components/PaginatedTable'
  // import TypeVehicleModal from './TypeVehicleModal'
  import EditPenaltyModal from './EditPenaltyModal'
  export default {
    props: {
      vehicleUuid: {
        type: String,
        required: false
      }
    },
    components: {
      PaginatedTable,
      // TypeVehicleModal
      EditPenaltyModal
    },
    data: function() {
      var currentDate = new Date();
      var twoDigitFirstMonth= '01';  
      var twoDigitFirstDate= '01';
      var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;
      
      var currentDate = new Date();
      var twoDigitLastMonth= '12';  
      var twoDigitLastDate= '31';
      var createdDateBy = currentDate.getFullYear() + "-" + twoDigitLastMonth + "-" + twoDigitLastDate;

      return {
        dataKey: "vehicleBillInfo",
        type: "Penalty",
        isLoading: false,
        apiUrl: {
          vehicleRequest: window.AppConfig.apiUrl + 'vehicle-request',
          vehicleBill: window.AppConfig.apiUrl + 'vehicle-bill-info?vehicle_uuid=' + this.vehicleUuid + '&type=Penalty&start_due_date=' + createdDateTo + '&end_due_date=' + createdDateBy,
          exportPenalty: window.AppConfig.apiUrl + 'export-vehicle-bill-general'
        },
        columns: [
          // {
          //   label: 'Bill Number',
          //   key: 'billNumber',
          //   sortable: false
          // },
          {
            key: 'issuedBy',
            label: 'Issued By',
            sortable: false
          },
          {
            key: 'createdAtType',
            label: 'Issued Date',
            sortable: false
          },
          {
            key: 'typeDate',
            label: 'Penalty Date',
            sortable: false
          },
          {
            key: 'amounts',
            label: 'Amount',
            sortable: false
          },
          {
            key: 'paidDateVehicle',
            label: 'Paid Date',
            sortable: false
          },
          {
            key: 'notes',
            label: 'Note',
            sortable: false
          },
          {
            key: 'statusType',
            label: 'Status',
            sortable: false
          },
          {
            key: 'actions',
            label: '',
            sortable: false
          }
        ],
        vehicleRequestList: []
      }
    },
    mounted() {
      this.getPenaltyBill()
    },
    methods: {
      getPenaltyBill () {
        this.isLoading = true
        this.$refs.dataTable.getDataTable()
      },
      getDateTime (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD HH:mm A')
        } else {
          return '-'
        }
      },
      doExportToExcel () {
        let url = this.apiUrl.exportPenalty + '?token=' + this.$store.getters['account/tokens'].access_token + '&type=Penalty&vehicle_uuid=' + this.vehicleUuid
        
        window.open(url)
      },
      // doModal () {
      //   this.$refs.typeVehicleModal.showModal()
      // },
      doEdit (row) {
        this.$refs.editPenalty.showModal(row)
      },
      doShowModal (row) {
        this.$refs.editRoadTax.showModal(row)
      },
    }
  }
</script>